

import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
const Login = lazy(() => import("../views/security/login"));



export default function SecurityRouting() {

    return (
        <Suspense fallback={null}>
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Login />} /> 
        </Routes>
        </Suspense>
    )
}

